import {makeStyles} from "@material-ui/core";
import {grey, orange, red} from "@material-ui/core/colors";

const useStyles = makeStyles(({spacing, palette}) => ({
  root: {
    width: "480px",
    padding: spacing(3, 3, 2, 3),
    backgroundColor: "white",
    borderRadius: "8px",
  },
  title: {
    fontSize: "24px",
    fontWeight: 500,
  },
  subtitle: {
    fontSize: "12px",
    lineHeight: "120%",
    letterSpacing: "1.2px",
    color: grey[600],
  },
  cancelSurchargeButton: {
    color: red[500],
  },
  seeList: {
    color: palette.primary.main,
    fontWeight: 500,
    lineHeight: "150%",
  },
  errorListRoot: {
    backgroundColor: orange[50],
    borderRadius: "8px",
  },
  overwrittenList: {
    width: "100%",
    maxHeight: spacing(45),
    overflowY: "auto",
  },
  warningTitle: {
    fontSize: "24px",
    fontWeight: 500,
  },
  warningContent: {
    fontSize: "16px",
    "& b": {
      fontWeight: 700,
    },
  },
  warningRoot: {
    backgroundColor: "white",
    padding: spacing(3, 3, 2, 3),
    borderRadius: "8px",
    width: "480px",
  },
}));

export default useStyles;
